export default __webpack_public_path__ + "static/selinux-a4d7d38066c9442239899111475a7918.png";